import React, { useEffect, useState } from "react";
import ModalComponent from "components/UI/MaterialUIComponents/ModalComponent";
import { AddMaterialIcon } from "Icons/MaterialIcons";
import { useHistory } from "react-router-dom";
import { detectTouchScreen } from "Functions/functions";
import BranchOffices from "./BranchOffices";
import FormAddOrEditBranchOffice from "./FormAddOrEditBranchOffice";
import "./EditBranchOffices.scss";

const EditBranchOffices = () => {
	const history = useHistory();
	const [stateModal, setStateModal] = useState(false);
	const [touchScreen, setTouchScreen] = useState();
	const [items, setItems] = useState([]);

	if (
		window.localStorage.getItem("account") === "false" ||
		window.localStorage.getItem("account") === false
	) {
		history.push("/ingresar");
	}

	useEffect(() => {
		detectTouchScreen(setTouchScreen);
	}, []);

	return (
		<div className="editBranchOffices">
			<ModalComponent
				stateModal={stateModal}
				setStateModal={setStateModal}
				scrollable={true}
				slotOpenModal={
					<span className={touchScreen ? "floatBtn touchScreen" : "floatBtn"}>
						<AddMaterialIcon className="floatBtn__addIcon" />
						<span className="floatIcon__textSpan">
							<span>Agregar Producto</span>
						</span>
					</span>
				}
			>
				<FormAddOrEditBranchOffice type="add" items={items} setItems={setItems} setStateModal={setStateModal} />
			</ModalComponent>
			<BranchOffices edit={true} setItems={setItems} items={items} />
		</div>
	);
};

export default EditBranchOffices;
